export const IDLE = 'idle';
export const PENDING = 'pending';
